import React, {ChangeEvent} from "react";
import {AppApi} from "../../../../utils/AppApi";
import {useAlert} from "../../../../utils/components/providers/AlertProvider";
import {Utils} from "../../../../utils/Utils";
import {MembershipType} from "./MembershipTypes";

export default function EditMembershipType(params: {
    show: boolean, membershipType: MembershipType,
    close: (membership?: MembershipType) => void
}) {
    const {showMessage} = useAlert()
    const [membership, setMembership] = React.useState(params.membershipType)

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        setMembership({...membership, [event.target.name]: event.target.value})
    }

    const saveMembershipType = () => {
        Utils.toggleSpinner('show')
        AppApi.saveMembership({
                membership_type_id: membership.membership_type_id,
                registration_fee  : membership.registration_fee,
                type_name         : membership.type_name.trim()
            })
            .then(res => {
                Utils.toggleSpinner('hide')
                if (res.data.success) {
                    params.close({...membership, membership_type_id: res.data['membership_type_id']})
                } else {
                    showMessage({message: res.data.message, type: 'error'})
                }
            })
            .catch(() => {
                Utils.toggleSpinner('hide')
                showMessage({message: 'Error saving membership type, please retry', type: 'error'})
            })
    }

    React.useEffect(() => {
        setMembership(params.membershipType)
    }, [params.membershipType])

    return (
        <div className={`modal_container ${params.show ? 'show' : ''}`.trim()}>
            <div className="modal_body">
                <h6 className="mb-4">{params.membershipType.membership_type_id === 0 ? 'Add Member Type' : 'Edit Member Type'}</h6>

                <form method="post">
                    <div className="mb-3">
                        <label htmlFor="type_name" className="form-label">Type Name</label>
                        <input type="text" className="form-control" id="type_name" name="type_name"
                               value={membership.type_name} onChange={handleChange} required/>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="registration_fee" className="form-label">Registration Fee</label>
                        <input type="number" step="0.01" min="0" className="form-control" id="registration_fee" name="registration_fee"
                               value={membership.registration_fee} onChange={handleChange} required/>
                    </div>
                </form>

                <div className={'form_buttons'}>
                    <div className={'row m-0'}>
                        <div className={'col-6 ps-0 pe-1'}>
                            <button type="button" className="btn btn-secondary" onClick={() => params.close()}>Close Window</button>
                        </div>
                        <div className={'col-6 ps-1 pe-0'}>
                            <button type="button" className="btn btn-primary" onClick={saveMembershipType}>Save Data</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}